import Comparison from '@/types/comparison';
import { formatLocalizedString, FormattedHTMLMessage } from '@/utils/i18n';
import React, { FC, ReactElement } from 'react';

interface Props {
  showTop?: boolean;
  isMissingAllItems?: boolean;
  isAllMissingOrUnallocatedPortfolios?: boolean;
  comparison: Comparison;
}

const MissingItemsBody: FC<Props> = ({ showTop = true, isMissingAllItems, isAllMissingOrUnallocatedPortfolios, comparison }): ReactElement => {
  const bodyTextKey = isMissingAllItems || isAllMissingOrUnallocatedPortfolios ? 'MissingAllItems' : 'MissingSomeItems';

  return (
    <>
      {showTop && (
        <p>
          <FormattedHTMLMessage
            id={`ComparisonMissingItemsModal.Body.${bodyTextKey}.Top`}
            values={{ count: comparison.missingItems?.length, comparison: comparison.name }}
          />
        </p>
      )}
      {!isMissingAllItems && !isAllMissingOrUnallocatedPortfolios && (
        <ul className="items-list">
          {comparison.missingItems?.map(i => (
            <li key={i._id}>{formatLocalizedString(i.name)}</li>
          ))}
        </ul>
      )}
    </>
  );
};

export default MissingItemsBody;
